export default "__VITE_ASSET__D4vnXCiQ__"